export const dataTable = {
  all: 'All',
  applyFilters: 'Apply filters',
  clear: 'Clear',
  clearAll: 'Clear all',
  columns: 'Columns',
  elements: 'elements',
  errorDescription: 'Error loading table data. Please try again.',
  filters: 'Filters',
  from: 'From',
  fromGreaterThanTo: 'From date cannot be greater than to date',
  goToFirstPage: 'Go to first page',
  goToLastPage: 'Go to last page',
  goToNextPage: 'Go to next page',
  goToPreviousPage: 'Go to previous page',
  max: 'Max',
  min: 'Min',
  minGreaterThanMax: 'Minimum cannot be greater than maximum',
  noResultsFound: 'No results found',
  of: 'of',
  page: 'Page',
  rowsPerPage: 'Rows per page',
  searchIn: 'Search in {column}',
  searchPlaceholder: 'Search...',
  selectStatus: 'Select status',
  showAll: 'Show all',
  textAdvanced: {
    addCondition: 'Add condition',
    removeCondition: 'Remove condition',
    placeholder: 'Value…',
    invalidRegex: 'Invalid regex pattern',
  },
  textOperator: {
    contains: 'contains',
    notContains: 'does not contain',
    regex: 'regex',
    notRegex: 'not regex',
    equals: 'equals',
    notEquals: 'not equals',
    oneOf: 'is one of',
  },
  to: 'To',
  toggleColumns: 'Toggle columns',
} as const
